import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

const useManageFailedCheckoutModal = () => {
  const { t } = useTranslation(TranslationContext.Checkout);

  return { t };
};

export default useManageFailedCheckoutModal;
